import { shopPrefix } from '../../config';
import { http } from '../axios';
import { SetAmountByLineItemKeysRequest } from '../selection-list/setAmountBulkInListByLineItemKeys';
import { BulkActionResponse } from '../../store/api';

const url = `${shopPrefix}/v2/shoppingcart/bulk/quantity/lineItemKeys/setAmount`;

export const setAmountBulkInCartByLineItemKeys = (body: SetAmountByLineItemKeysRequest) => {
    return http.put<BulkActionResponse>(url, body).then(res => res.data);
};
